import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { MultiBulletChart, BulletChartOptions } from '../../../charting/index';
import { IDynamicCompileService } from '../../services/dynamicCompileService';

export interface ImultiBulletChartDirective extends ng.IDirective {
}

export interface ImultiBulletChartDirectiveScope extends ng.IScope {
    id: string;
    kpiList: any[];
    options: BulletChartOptions;
    ratio?: number;
}

export class MultiBulletChartDirective extends ChartDirectiveBase implements ImultiBulletChartDirective {
    static directiveId = 'wtMultiBulletChart';

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        super();
        this.scope = {
            id: '@',
            kpiList: '=',
            options: '=',
            ratio: '<?'
        };
        this.link.bind(this);
    }

    link = ($scope: ImultiBulletChartDirectiveScope, element, attrs, controller) => {
        if (!attrs.id) {
            console.error('Using a chart directive requires that an id is set to the directive.');
        } else {
            const containerName = attrs.id;
            element.attr('id', containerName);
            const manager = new SvgManager(containerName, new Margins(0, 0, 10, 0));

            const chart = new MultiBulletChart(manager);
            $scope.$watch(() => $scope.kpiList, (newValue: any[]) => {
                if (newValue) {
                    chart.update(newValue);
                    ($scope as any).series = newValue;
                    this._dynamicCompileService.compileGroup(element, <any>$scope);
                }
            }, true);

            $scope.$watch(() => $scope.ratio, () => {
                if ($scope.ratio) {
                    manager.margins(new Margins(0, 0, 10 * $scope.ratio, 0));
                    chart.ratio($scope.ratio);
                }
            });
        }
    }

}